export default __webpack_public_path__ + "static/media/resubmit-24.77e0e4b5.png";